import { render, staticRenderFns } from "./DiscoverSearchModal.vue?vue&type=template&id=4ed987dc"
import script from "./DiscoverSearchModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./DiscoverSearchModal.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports